<template>
  <section>

    <form class="project-form" @submit.prevent="updateProjectNow">
      <section class="form-left form-cont">
        <label class="input-cont input-cont_small"
               @click="setEditableOn"
               :class="{'disabled-input': !isEdit}">
          <p class="label">
            {{$t('roles.filters.name')}}
          </p>
          <input type="text"
                 :readonly="!isEdit"
                 @blur="onBeingEditing"
                 v-model="name">
        </label>
        <div class="owner-block">
          <div class="owner-head">
            <div class="owner-title">{{$t('labels.owner')}}</div>
            <button type="button"
                    @click="showAddOwner"
                    v-if="(permissionCheck > 3) && ($route.name === 'project-edit') && false"
                    class="add-new-owner">
              <span class="kek">{{$t('projects.addProject.userSelect')}}</span>
              <add-icon></add-icon>
            </button>
          </div>
          <ul class="owner-cont">
            <li v-if="ownerRole()">
              <div class="owner-person">
                <div class="avatar-cont"
                     v-if="ownerRole().user && ownerRole().user.contacts && ownerRole().user.contacts.avatar_url"
                     :style="{backgroundImage: `url(${ownerRole().user.contacts.avatar_url})`}"></div>
                <user-icon class="user-icon"
                           v-else></user-icon>
                <p class="star-wrap">
                  {{ownerRole().user.first_name}} <span v-if="ownerRole().user.second_name">{{ownerRole().user.second_name}}</span>
                  <span class="star"><starIcon/></span>
                </p>
              </div>
              <!--<div class="owner-btn" v-if="false">-->
                <!--<dotsIcon :fill="'rgba(0, 82, 127, .5)'" />-->
              <!--</div>-->
            </li>
            <li v-for="owner in projectOwners">
              <div class="owner-person">
                <div class="avatar-cont"
                     v-if="owner.user && owner.user.contacts && owner.user.contacts.avatar_url"
                     :style="{backgroundImage: `url(${owner.user.contacts.avatar_url})`}"></div>
                <user-icon class="user-icon"
                           v-else></user-icon>
                <p class="star-wrap" v-if="owner.user && owner.user.first_name">
                  {{owner.user.first_name}} <span v-if="owner.user.second_name">{{owner.user.second_name}}</span>
                </p>
              </div>
              <button type="button"
                      @click="showDelOwner(owner.user.first_name, owner.user.second_name, owner.id)"
                      class="owner-btn hint-cont" >
                <dotsIcon :fill="'rgba(0, 82, 127, .5)'" />
                <p class=" btn-hint  btn-hint_top">
                  {{$t('btns.users.delUser')}}
                </p>
              </button>
            </li>

          </ul>
        </div>

        <label class="textarea-wrap"
               @click="setEditableOn"
               :class="{'disabled-input': !isEdit}">
          <p class="label" >
            {{$t('forms.descLb')}}
          </p>
          <textarea :readonly="!isEdit"
                    @blur="onBeingEditing"
                    v-model="desc"></textarea>
        </label>
      </section>
      <section class="project-properties-tab">
        <section class="form-right form-cont">
          <upload-file :old-img="oldImg"
                       :disabled="permissionCheck < 2"
                       @del="delAvatar();setEditableOn()"
                       @upload="uploadAvatar($event);setEditableOn()"></upload-file>
        </section>
      </section>
    </form>
  </section>
</template>

<script>
  import {mapMutations, mapGetters, mapState, mapActions} from 'vuex'
  import uploadFile from '../../../../components/uploadFileBig'
  import addIcon from '../../../Svg/projects/addUser'
  import dotsIcon from '../../../../components/Svg/things/dotsIcon'
  import starIcon from '../../../Svg/projects/starIcon'
  import {singleProject} from "../../../../mixins/projects/singleProject";
  import {showOverlay} from "../../../../mixins/utils/showOverlay";
  import userIcon from '../../../../components/Svg/users/user'
  import {delItem3} from "../../../../mixins/delItem3";
  import {loaderMixin} from "../../../../mixins/utils/loaderMixin";

  export default {
    name: "projectSettings",
    mixins: [singleProject, showOverlay, delItem3, loaderMixin],
    components: {uploadFile, addIcon, dotsIcon, starIcon, userIcon},
    data() {
      return {
        avatarFile: '',
        oldImg: '',
        avatarChanged: false,
        avatarDel: false,
        disabled: true,
        name: '',
        tag: '',
        desc: '',
        loading: false,
        // onBeingEditing: false,
        editedFields: {},
        delOwnerId: '',
      }
    },
    computed: {
      ...mapState({
        isEdit: state => state.projects.onSettingsNodeEdit,
        isHeaderSettingsEditActive: state => state.projects.isHeaderSettingsEditActive,
        thisProject: state => state.projects.singleProject,
        allRoles: state => state.projects.allRoles
      }),
      ...mapGetters({
        projectOwner: 'projects/projectOwnerRole',
      }),
      projectOwners() {
        if (this.project) {
          let owners = this.project.permissions.filter(item => item.value > 3);
          for (let role of this.allRoles) {
            for (let owner of owners) {
              if (role.id == owner.role_id) {
                owner.user = role.user;
                break;
              }
            }
          }
          return owners
        }
      }
    },
    watch: {
      $route(val) {
        this.updateProjectInfo()
      }
    },
    methods: {
      ...mapMutations({
        setEditedFields: 'projects/SET_ON_EDITING_INPUTS',
        setSettingsNodeEditable: 'projects/SET_SETTINGS_NODE_EDITABLE',
        setHeaderSettingsEditActive: 'projects/SET_HEADER_SETTINGS_EDIT_ACTIVE',
        showAddPermission: 'projects/SET_SHOW_ADD_PERMISSION',
        setPermissionType: 'projects/SET_ADD_PERMISSION_TYPE'
      }),
      ...mapActions({
        getProjects: 'projects/getProjects',
        addProject: 'projects/createProject',
        updateProject: 'projects/updateProject',
        delProject: 'projects/delProject',
        removePermission: 'projects/removePermission',
      }),
      showDelOwner(name, secondName, id) {
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setNumberDel(3);
        this.setDelItems(name + ' ' + secondName);
        this.delOwnerId = id;
      },
      async deleteItems3() {
        this.showLoader()
        await this.removePermission({
          data: {
            ids: JSON.stringify(this.delOwnerId)
          },
          id: this.$route.params.id
        });
        await this.getProjects();
        this.delOwnerId = '';
        this.hideLoader()
      },
      ownerRole() {
        return this.projectOwner(this.singleProject.owner_role_id)
      },
      showAddOwner() {
        this.showOverlay(true);
        this.showAddPermission(true);

        this.setPermissionType('user');
      },
      uploadAvatar(file) {
        this.avatarFile = file;
        this.onBeingEditing();
      },
      delAvatar() {
        if (this.oldImg) {
          this.avatarFile = 'del';
          this.oldImg = ''
        } else {
          this.avatarFile = '';
          this.oldImg = ''
        }
        this.onBeingEditing();
      },
      setEditableNodeSettings(val) {
        this.setSettingsNodeEditable(val);
        this.setHeaderSettingsEditActive(val)
      },
      setEditableOn() {
        if (this.permissionCheck > 3) {
          this.setEditableNodeSettings(true)
        }
      },
      setEditableOff() {
        this.setEditableNodeSettings(false)
      },
      onBeingEditing() {
        this.editedFields = {
          name: this.name,
          description: this.desc,
          image: this.avatarFile
        };

        this.setEditedFields(this.editedFields)
      },
      async delProjectNow() {
        await this.delProject(+this.$route.params.id)
          .then(res => {
            this.getProjects();
            this.$router.push({ name: 'projects' })
          })
      },
      updateProjectInfo() {
        this.name = this.project.name
        this.desc = this.project.description;
        this.oldImg = this.project.image_url
      }
    },
    mounted() {
      this.updateProjectInfo();
    },
    beforeDestroy() {
      this.setEditableOff()
    }
  }
</script>

<style lang="scss" scoped>
  input {
    max-height: 40px;
  }

  .project-form {
    font-family: $mm;
    display: flex;
    justify-content: space-between;
    height: 100%;
    padding: 30px 20px;

    .form-right {
      max-width: 220px;
      width: 100%;

      .drug-field {
        padding: 0 14px !important; //?????????????
      }
    }

    .form-left {
      width: calc(100% - 40px - 220px);
      margin-right: 40px;
      height: 100%;
      display: flex;
      flex-direction: column;
      min-height: calc(100vh - 210px - 80px - 20px);
    }

    .label {
      font-size: 13px;
    }
  }

  .input-cont {
    border-bottom: 1px solid $grey;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  .owner-block {
    border-bottom: 1px solid $grey;
    margin-bottom: 16px;

    .owner-head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
    }

    .add-new-owner {
      font-family: $mm;
      font-size: 10px;
      color: $lightBlue;
      display: flex;
      align-items: center;

      svg {
        margin-left: 10px;
      }

    }
  }
  .owner-cont {
    font-size: 14px;
    color: $darkBlue;

    .owner-person {
      display: flex;
      align-items: center;

      .avatar-cont, .user-icon {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-right: 10px;
      }
    }

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .owner-btn svg {
      width: 20px;
      height: 20px;
      transition: $anim;
      border-radius: 50%;

      &:hover {
        background: $grey;
      }
    }
  }

  .tags-block {
    margin-bottom: 16px;
    border-bottom: 1px solid $grey;
    padding-bottom: 16px;

    .tags-head {
      margin-bottom: 16px;
    }

    .tags-cont {
      display: flex;
      flex-wrap: wrap;
      margin: -4px -4px;
    }
    .tags-single {
      margin: 4px 4px;
      padding: 4px 12px;
      background-color: transparent;
      line-height: 24px;
      border: 0.5px solid $blue;
      color: $blue;
      border-radius: 6px;
      font-size: 14px;
    }
  }

  .owner-title,
  .tags-head {
    font-size: 13px;
    color: rgba(0, 82, 127, .5);
  }

  .star-wrap {
    position: relative;
    .star {
      position: absolute;
      right: -12px;
      top: -5px;
      width: auto;
      height: auto;
    }
  }

  //выравнивание отключенных инпутов
  input[readonly], textarea[readonly] {
    transform: translateX(-14px);
  }

</style>
